import withUnwrappedEvent from '@/components/hoc/withUnwrappedEvent';
import withValueUpdater from '@/components/hoc/withValueUpdater';
import TextField from './TextField';

const UnwrappedTextField = withUnwrappedEvent(TextField);

export const DynamicTextField = withValueUpdater(UnwrappedTextField);
export const DynamicNullableTextField = withValueUpdater(UnwrappedTextField);
